import React from 'react';
import PropTypes from 'prop-types';
import { Box, InputAdornment, TextField, Typography } from '@material-ui/core';
import { useStyles } from './styles.js';
import cn from 'classnames';
import HelperText from '../HelperText';
import { maskUserEmail } from 'utils/utilities.js';

const Input = ({
    label,
    labelClass,
    wrapperClass,
    type,
    name,
    onChange,
    error,
    value,
    helperText,
    placeholder,
    StartAdornmentIcon,
    EndAdornmentIcon,
    onClickEndIcon,
    enableMask = false,
    disabled,
    readOnly,
    inputContainerRef,
    ...restInputProps
}) => {
    const styles = useStyles();
    return (
        <Box className={cn(styles.inputWrapper, wrapperClass)}>
            {label && <Typography className={cn(styles.label, labelClass)}>{label}</Typography>}
            <Box ref={inputContainerRef}>
                <TextField
                    type={type || 'text'}
                    variant="outlined"
                    name={name}
                    value={value}
                    onChange={onChange}
                    fullWidth
                    error={error}
                    helperText={helperText}
                    placeholder={placeholder}
                    disabled={disabled}
                    inputProps={{
                        readOnly: readOnly,
                    }}
                    InputProps={{
                        classes: {
                            root: cn(styles.inputRoot, wrapperClass),
                            input: styles.inputField,
                            error: styles.error,
                            notchedOutline: styles.notchedOutline,
                            focused: styles.focused,
                            disabled: styles.disabled,
                        },
                        startAdornment: StartAdornmentIcon && (
                            <InputAdornment position="start" className={styles.adornmentIcon}>
                                <StartAdornmentIcon />
                            </InputAdornment>
                        ),
                        endAdornment: EndAdornmentIcon && (
                            <InputAdornment
                                position="end"
                                className={styles.adornmentIcon}
                                disablePointerEvents={disabled}
                                onClick={onClickEndIcon}
                            >
                                <EndAdornmentIcon />
                            </InputAdornment>
                        ),
                        value: enableMask ? maskUserEmail(value) : value,
                    }}
                    FormHelperTextProps={{
                        classes: {
                            root: styles.helperTextRoot,
                            contained: styles.helperTextContained,
                            error: styles.helperText,
                        },
                        component: () => <HelperText>{helperText}</HelperText>,
                    }}
                    {...restInputProps}
                />
            </Box>
        </Box>
    );
};

Input.propTypes = {
    label: PropTypes.string,
    labelClass: PropTypes.string,
    wrapperClass: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    error: PropTypes.bool,
    value: PropTypes.string,
    helperText: PropTypes.string,
    placeholder: PropTypes.string,
    StartAdornmentIcon: PropTypes.node,
    EndAdornmentIcon: PropTypes.node,
    onClickEndIcon: PropTypes.func,
    enableMask: PropTypes.bool,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    inputContainerRef: PropTypes.object,
};

export default Input;
